import { FillLockIcon, UnlockIcon } from "@/styles/icons";

export const formattedCreditCardStatus = (status: string) => {
    const formatStatus = {
        REFUNDED: "Estornado",
        PROCESSING: "Processando",
        APPROVED: "Aprovado",
        DECLINED: "Não aprovado",
        CANCELLED: "Cancelado"
    }
    return formatStatus[status] || status;
}
export const formattedCreditCardStatusColor = (status: string) => {
    const formatStatusColor = {
        REFUNDED: "warning",
        PROCESSING: "info",
        APPROVED: "success",
        DECLINED: "error",
        CANCELLED: "error"
    }
    return formatStatusColor[status] || status;
}

export function formatInvoiceStatusIcon(status: string) {
    const cardStatusIcon = {
      OPEN: <UnlockIcon size={14}  />,
      CLOSED: <FillLockIcon size={14}  />,
      LATE: <FillLockIcon size={14}  />
    }
    return cardStatusIcon[status] || <FillLockIcon size={14}  />
}
export function formatInvoiceStatusText(status: string) {
  const cardStatusIcon = {
    OPEN: "Aberta",
    CLOSED: "Fechada",
    OVERDUE: "Atrasada",
    PAID: "Paga"
  }
  return cardStatusIcon[status];
}